import { defineMessages } from 'react-intl';

export default defineMessages({
  shiftCreationFailed: {
    id: 'app.components.WeekplanCalendar.shiftCreationFailed',
    defaultMessage: 'Failed to create the shift.',
  },
  shiftCreationSucceeded: {
    id: 'app.components.WeekplanCalendar.shiftCreationSucceeded',
    defaultMessage: 'Shift successfully created.',
  },
});
